function getTimestampInSeconds() {
  return Math.floor(Date.now() / 1000)
}

export default getTimestampInSeconds
